module.exports = __webpack_public_path__ + "static/media/aldi4.c0c98bb5.jpg";